module.exports = __webpack_public_path__ + "static/media/email.0cfa8f96.svg";